/* app/js/src/components/reports/gaps-report/gaps-report.component.scss */
.report-header-dark {
  color: #232f3a;
  width: 450px;
  padding-left: 20px;
  float: left;
}
.report-header-light {
  color: #879baf;
  font-weight: normal !important;
}
.preloader {
  text-align: center;
}
.close-gap-btn {
  margin-top: 12px;
  float: right;
}
.row-header {
  color: #879baf;
  font-weight: normal !important;
}
.report-header-row {
  height: 65px;
  width: 750px;
}
.no-gaps-message {
  background-color: white;
  height: 335px;
  text-align: center;
}
.no-gaps-message .message {
  font-size: 24px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
  color: #232f3a;
  padding-top: 50px;
}
.no-gaps-message .message b {
  font-weight: 600;
}
.success-icon {
  display: inline-block;
  margin-top: 40px;
}
/*# sourceMappingURL=gaps-report.component.css.map */
